import { ModelMetier } from './../../providers/model-metier';
import { MyFirebaseList } from './../../providers/my-firebase-list';
import { MyFirebase } from './../../providers/my-firebase';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


/**
 * Generated class for the InfoLicidPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-info-licid',
  templateUrl: 'info-licid.html',
})
export class InfoLicidPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public modelMetier : ModelMetier, public myFirebase : MyFirebase ) {

    this.licIds = this.myFirebase.getList( ModelMetier.getLicIdsElesRef(), null );
    this.clouds = this.myFirebase.getList( ModelMetier.getCloudsElesRef(), ModelMetier.getCloudsChildrenRef() );

  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad InfoLicidPage');
  }



  // List of licId /licIds/{licId}/cloudId
  licIds : MyFirebaseList;

  // List of cloud /clouds/{cloudId}/cloud
  clouds : MyFirebaseList;


  // Raw input lic ids
  private strLicIds:string;

  // Split, filter lic id Array
  private tabLicId : string[];


  cloudInfo() {

    this.tabLicId = this.modelMetier.getLicIds(this.strLicIds);

  }

  // Return the cloud for licId
  getCloud(licId) {

    let ele = this.licIds.getEleId( this.modelMetier.licId2fbKey(licId) );
    if (!ele) return this.clouds.elesFilterKeyValue[0].value;
    return this.clouds.getEleId( ele.cloudId );
  }


}


/*

TODO
  
  merge possible avec ecran d'attachement de licIDs a cloud
  laison entre les 2, pour verification avant de programmer, ex btn ? ou link info


*/



// WEBPACK FOOTER //
// ./src/pages/info-licid/info-licid.ts